import Courier from '../components/Courier.vue'
import Appointments from '../components/Appointments.vue'
import Subscriptions from '../components/Subscriptions.vue'
import AddSubscription from '../components/AddSubscription.vue'
import AdminSubscriptions from '../components/AdminSubscriptions.vue'
import SignIn from '../components/SignIn.vue'
import SignUp from '../components/SignUp.vue'
import Dashboard from '../components/Dashboard.vue'
import Shopping from '../components/Shopping.vue'
import ItServices from '../components/ItServices'
import RepairServices from '../components/RepairServices'
import Orders from '../components/Orders'
import Users from '../components/Users'
import Riders from '../components/Riders'
import Profile from '../components/Profile'
import Departments from '../components/Departments'
import Clients from '../components/Clients'
import Roles from '../components/Roles'
import TopUps from '../components/TopUps'
import Categories from '../components/Categories'
import Products from '../components/Products'
import Deliveries from '../components/Deliveries'
import OrderedItems from '../components/OrderedItems'
import LPOs from '../components/LPOs'
import Billing from '../components/Billing'
import TopUp from '../components/TopUp'
import Accounts from '../components/Accounts'
import AddDelivery from '../components/AddDelivery'
import DeliveryItems from '../components/DeliveryItems'
import Auth from '../components/Auth'
import ResetPassword from '../components/ResetPassword'
import NewResetPassword from '../components/NewResetPassword'
import RiderSiderBar from '../components/RiderSiderBar'
import CostingVariables from '../components/CostingVariables'
import AdminDeliveries from '../components/AdminDeliveries'
import OperationTimes from '../components/OperationTimes'
import ClientsDeliveriesReport from '../components/ClientsDeliveriesReport'
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  hashbang: true,
  linkActiveClass: 'active',
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: '/dashboard'
    },
    {
      meta: { auth: false },
      path: '/auth',
      name: 'auth',
      component: Auth,
      children: [
        {
          path: 'signIn',
          name: 'signIn',
          component: SignIn
        },
        {
          path: 'signUp',
          name: 'signUp',
          component: SignUp
        },
        {
          path: 'passwordReset',
          name: 'passwordReset',
          component: ResetPassword,
          props: true
        },
        {
          path: 'passwordReset/:token',
          name: 'passwordResetToken',
          component: NewResetPassword,
          props: true
        }
      ]
    },
    {
      meta: { auth: true },
      path: '/topUp',
      name: 'topUp',
      component: TopUp
    },
    {
      meta: { auth: true },
      path: '/operation-hours',
      name: 'operation-hours',
      component: OperationTimes
    },
    {
      meta: { auth: true },
      path: '/clients',
      name: 'clients',
      component: Clients
    },
    {
      meta: { auth: true },
      path: '/deliveries',
      name: 'deliveries',
      component: Deliveries
    },
    {
      meta: { auth: true },
      path: '/deliveryItems',
      name: 'deliveryItems',
      component: DeliveryItems
    },
    {
      meta: { auth: true },
      path: '/newDelivery',
      name: 'newDelivery',
      component: AddDelivery
    },
    {
      meta: { auth: true },
      path: '/roles',
      name: 'roles',
      component: Roles
    },
    {
      meta: { auth: true },
      path: '/lpos',
      name: 'lpos',
      component: LPOs
    },
    {
      meta: { auth: true },
      path: '/topUps',
      name: 'topUps',
      component: TopUps
    },
    {
      meta: { auth: true },
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },
    {
      meta: { auth: true },
      path: '/billing/:filter',
      name: 'billing',
      component: Billing
    },
    {
      meta: { auth: true },
      path: '/courier/:filter',
      name: 'courier',
      component: Courier
    },
    {
      meta: { auth: true },
      path: '/newOrder',
      name: 'newOrder',
      component: Shopping
    },
    {
      meta: { auth: true },
      path: '/orderedItems',
      name: 'orderedItems',
      component: OrderedItems
    },
    {
      meta: { auth: true },
      path: '/orders',
      name: 'orders',
      component: Orders
    },
    {
      meta: { auth: true },
      path: '/accounts',
      name: 'accounts',
      component: Accounts,
      props: true
    },
    {
      meta: { auth: true },
      path: '/appointments',
      name: 'appointments',
      component: Appointments
    },
    {
      meta: { auth: true },
      path: '/subscriptions/:filter',
      name: 'subscriptions',
      component: Subscriptions
    },
    {
      meta: { auth: true },
      path: '/newSubscription',
      name: 'newSubscription',
      component: AddSubscription
    },
    {
      meta: { auth: true },
      path: '/adminSubscriptions/:filter',
      name: 'adminSubscriptions',
      component: AdminSubscriptions
    },
    {
      meta: { auth: true },
      path: '/users',
      name: 'users',
      component: Users
    },
    {
      meta: { auth: true },
      path: '/riders',
      name: 'riders',
      component: Riders,
      children: [
        {
          path: '/riders/:id',
          name: 'riderDeatils',
          component: RiderSiderBar,
          props: true
        }
      ]
    },
    {
      meta: { auth: true },
      path: '/products',
      name: 'products',
      component: Products
    },
    {
      meta: { auth: true },
      path: '/categories',
      name: 'categories',
      component: Categories
    },
    {
      meta: { auth: true },
      path: '/orderItems',
      name: 'orderItems',
      component: OrderedItems
    },
    {
      meta: { auth: true },
      path: '/departments',
      name: 'departments',
      component: Departments
    },
    {
      meta: { auth: true },
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      meta: { auth: true },
      path: '/repairs',
      name: 'repairs',
      component: RepairServices
    },
    {
      meta: { auth: true },
      path: '/it',
      name: 'it',
      component: ItServices
    },
    {
      meta: { auth: true },
      path: '/costingVariables',
      name: 'costingVariables',
      component: CostingVariables
    },
    {
      meta: { auth: true },
      path: '/newAdminDeliveries',
      name: 'newAdminDeliveries',
      component: AdminDeliveries
    },
    {
      meta: { auth: true },
      path: '/sendReports/:filter',
      name: 'sendReports',
      component: ClientsDeliveriesReport
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js